import React from 'react';
import Table from 'react-bootstrap/Table';

import TableHeader from './TableHeader';
import TableRow from '../list/TableRow';
import ApiUiController from '../../controller/ApiUiController';
import FieldListPopup from './FieldListPopup';

import './Table.css';

class TableUI extends React.Component {

  constructor(props) {
    super(props);
    this.state = { fields : props.fields, listPopup: false };
  }

  UNSAFE_componentWillReceiveProps(props) {
    const len = props.fields.length > this.state.fields.length ? props.fields.length : this.state.fields.length;
    for (let i = 0; i < len; i++) {
      if ( i === props.fields.length || i === this.state.fields.length || props.fields[i] !== this.state.fields[i] ) {
        this.setState({ ...this.state, fields: props.fields, listPopup: false});
        break;
      }
    }
  }

  showListPopup = () => this.setState({ ...this.state, listPopup: !this.state.listPopup });

  onFieldSelection = fields => {
    this.setState({...this.state, fields : fields, listPopup: false});
    this.props.onFieldSelection(fields);
  }

  render() {
    const data = this.props.data;
    const model = this.props.model;
    const visibleFields = this.state.fields;
    const pagination = this.props.pagination;

    let list;
    if (!data || data.length === 0) {
      list = <tr><td colSpan={visibleFields.length + 2}>No Records Found</td></tr>;
    } else {
      list = data.map( (lead, _i) => (
        <TableRow className="table-responsive"
          key={_i.toString()}
          fields={visibleFields}
          model={model.fields}
          data={lead}
          fieldLength={visibleFields.length + 2}
          page={pagination.currentPage}
          index={_i}
          perPage={pagination.perPage}
          onPreview={this.props.onPreview}
          onAddEdit={this.props.onAddEdit}
          onDelete={this.props.onDelete}
          preview={this.props.preview}
          update={this.props.update}
          delete={this.props.delete}
          findProperties={this.props.findProperties}
          findLeads={this.props.findLeads}
          selected={this.props.selected}
          onSelect={this.props.onSelect}
          onRemove={this.props.onRemove}
          onCallClick={this.props.onCallClick}
          onMeetingClick={this.props.onMeetingClick}
          actions={this.props.actions}
        />
      ));
    }
    
    return (
      <>
        { this.state.listPopup &&
          <FieldListPopup
            onFieldSelection={this.onFieldSelection}
            visibleFields={visibleFields}
            fields={this.props.model.fields}
          />
        }
        <div className={`col-md-${this.props.isFilterOpen ? 9 : 12}`}>
          <ApiUiController inApiCall={this.props.inApiCall}>
            <div className='table-scroll'>
              <Table striped bordered hover className="table-cursor"
                style={{
                  display: 'block',
                  overflowX: 'scroll',
                  whiteSpace: 'wrap',
                  scrollbarWidth: 'thin'
                  }}>
                <TableHeader
                  fields={visibleFields}
                  model={model}
                  showListPopup={this.showListPopup}
                  showMassUpdate={this.props.showMassUpdate}
                  onSelectAll={this.props.onSelectAll} onRemoveAll={this.props.onRemoveAll}
                  order={this.props.order}
                  onOrderChange={this.props.onOrderChange}
                />
                <tbody className="listlead">{list}</tbody>
              </Table>
            </div>
          </ApiUiController>
        </div>
        </>
    );
  }
}
export default TableUI;